import React from 'react';
import styled from 'styled-components';
import color from '../styles/color';

const Container = styled.div`
  height: calc(100vh - 56px);
  padding: 50px;
  text-align: center;

  display: flex;
  flex-flow: column;
  justify-content: space-between;
`;

const ADContainer = styled.a`
  &,
  &:link,
  &:active {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 60px;
    text-decoration: none;
    color: currentColor;
  }
`;

const ADText = styled.h4`
  font-size: 22.5px;
  font-weight: 400;
  padding: 0;
  margin: 0;
`;

const ADArrow = styled.div`
  display: block;
  height: 50px;
  width: 50px;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  transform: rotate(45deg) translate(0, 0);
  animation: moving-arrow 1.25s linear infinite;

  @keyframes moving-arrow {
    0% {
      transform: rotate(45deg) translate(0, 0);
    }

    25% {
      transform: rotate(45deg) translate(-3px, -3px);
    }

    50% {
      transform: rotate(45deg) translate(-6px, -6px);
    }

    75% {
      transform: rotate(45deg) translate(-3px, -3px);
    }
    100% {
      transform: rotate(45deg) translate(0, 0);
    }
  }
`;

const Header = styled.h1`
  display: flex;
  flex-flow: column;
  text-align: center;
  line-height: 1.7;
`;

const Subtitle = styled.span`
  display: block;
  font-size: 1.75rem;
  font-weight: 400;
  color: ${color.ippdDarker};
`;

const Chapter = styled.span`
  display: block;
  font-weight: 600;
  color: #a9a9a9;
  font-size: 1.25rem;
`;

const Main = styled.span`
  display: block;
  font-size: 20px;
  font-weight: 400;
`;

const Intro = () => {
  return (
    <Container>
      <Header>
        <Subtitle>ประเทศไทยอยู่ตรงไหน</Subtitle>
        <Chapter>ตอน</Chapter>
        <Main>การจัดการถุงพลาสติกหูหิ้ว</Main>
      </Header>
      <ADContainer href="#plasticwaste1">
        <ADText>เลื่อนลง</ADText>
        <ADArrow />
      </ADContainer>
    </Container>
  );
};

export default Intro;
